<template>
  <div v-if="false" class="d-flex flex-column" style="gap: 4px">
    <v-btn @click="connectFacebook">connectFacebook</v-btn>
    <v-btn @click="changeLongLiveToken">changeLongLiveToken</v-btn>
    <v-btn @click="getMe">getMe</v-btn>
  </div>
</template>

<script>
export default {
  data: () => ({
    appId: "28912777431674359", // 28912777431674359 [ecom], 724484533935661 [me]
    appSecret: "324a539eb27f9683a47580aad5e583c9", // 324a539eb27f9683a47580aad5e583c9 [ecom], 39b6a56049e2f47c1411f9f714f9d59b [me]
    // appId: "28912777431674359", // 28912777431674359 [ecom], 724484533935661 [me]
    // appSecret: "324a539eb27f9683a47580aad5e583c9", // 324a539eb27f9683a47580aad5e583c9 [ecom], 39b6a56049e2f47c1411f9f714f9d59b [me]
    firstToken: {
      authResponse: {
        userID: "28735670316027453",
        expiresIn: 5184000,
        accessToken:
          "EAGa4BJRI7fcBSdFgGCevZBD98EnAQ4ExdSJpMWlMZAZCabwZB8KlhdoM1qipeVbZAxReoWC9XLfaMXUqhlZBYsNYBv7ravFAAXYXlca3g1YfP5xWJcIhUlk1IdDdRPnD6110DZAHYPN0t0rEAR7OSJjZBPlNJgaZCVF32MbZA1K1LYrOylcf3dtmSkGmyHlTkINl1FZALmB6xaJvENeH94SbKfZBh81lYA5dac1dMu8z3tvA",
        signedRequest:
          "0Jcxn64dGW-XRZc69RymYgnG3SzMLn7hcfQGFz0hYkg.eyJ1c2VyX2lkIjoiMjg3MzU2NzAzMTYwMjc0NTMiLCJjb2RlIjoiQVFMMmtZcGgzNlhpRU9Cai1sYmtoYThCbDB3ZVFxZjE4QzVTUGhBZnV0WFlSOWNsbENOVkJOakpYOEpjV3ZhTVlKRXRxM1JkRFpKWHBsR09Fek9kTXBfLU1hSTRwZEROVUZjSFhQdEJrRlRUSEN6Z253cWtGdlJIeXktX2t6cDFjMWZNQWFNWEVJMk1INDFUU2JzX0MyQU5jNURlUTA2SEtjMmpJeG1fX05CSjdtZk9SdWNyQTBlZGhXUVFlcGZHVU9DVEtKNU5ZdzktZEZPV24weWJVUDdwRDRQdTEwMkxqOFBNanBGVzd4elVNc3ZqZE1NcHF4b1ZBZ2paTkJRWVRuaUVDQ0tQMVM5YlVDZWEwdjV5ajgzZl9JRERTVWRMa1prSUxSMFZGMWpWdmR1TVBtY1RISl82UlRUZmwwWWJENWNJSUI4RF96RjZOU2ZGUUU2VlJtME42Q1ZSY0tDdGFWV3Fic2x3RUhpNnRaV3dIQ185TS1TSFhWdHFlTUhhWmtRIiwiYWxnb3JpdGhtIjoiSE1BQy1TSEEyNTYiLCJpc3N1ZWRfYXQiOjE3ODk0MzU0NzV9",
        graphDomain: "facebook",
        data_access_expiration_time: 1797211475,
      },
      status: "connected",
    },
    longLiveToken: {
      access_token:
        "EAGa4BJRI7fcBSYq1qx9PYDGwt6hRBMtDu8sEpr9F1HRHPCNBQI8Vv42SH5Kkcm6bOclCVVEGoblGZCH0tO8eOtcRF8zkCQZBZBeyZAxu3hDoY2vB0AzrD1LrGXi0s3OXn8vHjnLWwCHuYSprRWzm0uJxAs1S3jutkztZBRjWIDSnZAZBOfR9CTktH27pFzn",
      token_type: "bearer",
      expires_in: 5183948,
    },
    myDetail: {
      id: "",
      name: "",
    },
  }),
  async mounted() {
    // await this.initFacebook(this.appId);
  },
  methods: {
    initFacebook(appId) {
      return new Promise((resolve) => {
        window.fbAsyncInit = function () {
          window.FB.init({
            appId: appId,
            cookie: true,
            xfbml: true,
            version: "v21.0",
          });
          console.log("FB SDK Initialized!");
          resolve(); // บอกว่าโหลดและตั้งค่าเสร็จแล้ว
        };

        // Load SDK
        (function (d, s, id) {
          var js,
            fjs = d.getElementsByTagName(s)[0];
          if (d.getElementById(id)) {
            resolve();
            return;
          } // ถ้ามีอยู่แล้วก็ผ่านเลย
          js = d.createElement(s);
          js.id = id;
          js.src = "https://connect.facebook.net/en_US/sdk.js";
          fjs.parentNode.insertBefore(js, fjs);
        })(document, "script", "facebook-jssdk");
      });
    },
    // ========== ========== ========== ==========
    connectFacebook() {
      if (!window.FB) {
        alert("Facebook SDK ยังโหลดไม่เสร็จ กรุณารอครู่เดียวครับ");
        return;
      }

      // ========== ========== For User ========== ==========
      window.FB.login(
        (response) => {
          console.log(response);
          this.firstToken = response;
        },
        {
          config_id: 1104855732052141,
          // scope: ["public_profile", "email"].join(","),
        }
      );
    },
    async changeLongLiveToken() {
      try {
        const accessToken = this.firstToken.authResponse.accessToken;

        const url = `https://graph.facebook.com/v21.0/oauth/access_token?grant_type=fb_exchange_token&client_id=${this.appId}&client_secret=${this.appSecret}&fb_exchange_token=${accessToken}`;
        const res = await fetch(url);
        const data = await res.json();

        if (data) {
          console.log(data);
          this.longLiveToken = data;
        }
      } catch (error) {
        console.error("Error changeLongLiveToken:", error);
      }
    },
    async getMe() {
      let userToken =
        this.longLiveToken.access_token ||
        this.firstToken.authResponse.accessToken;

      try {
        const url = `https://graph.facebook.com/me?fields=id,name,email,picture.type(large)&access_token=${userToken}`; // for user
        const res = await fetch(url);
        const data = await res.json();
        console.log(data);

        this.myDetail = data;
      } catch (error) {
        console.error("Error", error);
      }
    },
  },
  computed: {
    link() {
      const pageId = "298137954240918";
      const asid = "123456789";
      const link = `https://m.me/${pageId}?ref=${asid}`;
      return link;
    },
  },
};
</script>

<style>
</style>